<template lang="pug">
.app-menu
  sidebar-menu(
    :menu="menu",
    width="300px",
    :collapsed="collapsed",
    @collapse="onCollapse"
  )
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu"
import acl from "@/lib/acl"
import departamento from "@/lib/departamento"
import { LocalStorageFacade } from "paliari-js-utils"
import "vue-sidebar-menu/dist/vue-sidebar-menu.css"
import title from "@/config/router/middlewares/title"

const KEY_MENU_COLLAPSED = "sidebar_collapse"

export default {
  components: { SidebarMenu },
  vuex: {
    departamentos: {
      state: ["current"],
      actions: ["setCurrent"],
    },
    "mensagens/recebidas": {
      state: ["countNaoLidas"],
      actions: ["fetchCount"],
    },
    "analises/minhasAnalises": {
      state: ["countAguardando"],
      actions: ["fetchCountAguardando"],
    },
  },

  watch: {
    countNaoLidas() {
      this.setMenu()
    },
    countAguardando() {
      this.setMenu()
    },
  },

  async created() {
    if (departamento.current) this.setCurrent(departamento.current)

    await this.fetchCount()
    await this.fetchCountAguardando()
    this.setMenu()
    this.countMessages()
    this.countMinhasAnalises()
  },

  destroyed() {
    clearInterval(this.interval)
  },

  computed: {
    collapsed: {
      get() {
        return LocalStorageFacade.getItem(KEY_MENU_COLLAPSED) || false
      },
      set(v) {
        LocalStorageFacade.setItem(KEY_MENU_COLLAPSED, v)
      },
    },
  },

  data() {
    return {
      menu: [],
    }
  },

  methods: {
    onCollapse(v) {
      this.collapsed = v
    },

    countMessages() {
      this.interval = setInterval(this.fetchCount, 60000)
    },

    countMinhasAnalises() {
      this.intervalMinhasAnalises = setInterval(
        this.fetchCountAguardando,
        60000,
      )
    },

    async setMenu() {
      let badgeMensagens = {}
      let badgeAnalises = {}

      if (this.countNaoLidas > 0) {
        badgeMensagens = {
          text: this.countNaoLidas,
          class: "vsm--badge_default text-light bg-primary",
          element: "span",
        }
      }

      if (this.countAguardando > 0) {
        badgeAnalises = {
          text: this.countAguardando,
          class: "vsm--badge_default text-light bg-primary",
          element: "span",
        }
      }

      this.menu = [
        {
          href: "/app/home",
          title: "OS-m Admin",
          icon: "fp fp-2x fp-osm text-primary",
          class: "text-primary",
        },
        {
          title: "",
          header: true,
        },
        {
          title: "OS-m",
          icon: "fa fa-fw fa-check-square-o",
          child: [
            {
              href: "/app/osm/servicos",
              title: "Serviços",
              icon: "fa fa-fw fa-check",
              disabled: !(await acl.allowed([
                "admin",
                "ordem_servicos",
                "index",
              ])),
            },
            {
              href: "/app/osm/solicitacoes",
              title: "Solicitações de Prazo",
              icon: "fa fa-fw fa-hourglass-end",
              disabled: !(await acl.allowed([
                "admin",
                "solicitacoes",
                "index",
              ])),
            },
            {
              href: "/app/osm/compartilhado/servicos",
              title: "Outros Departamentos",
              icon: "fa fa-fw fa-retweet",
              disabled: !(await acl.allowed([
                "admin",
                "compartilhado",
                "ordem_servicos",
                "index",
              ])),
            },
            {
              href: "/app/osm/servicos-detalhados",
              title: "Serviços Detalhados",
              icon: "fa fa-fw fa-check",
              disabled: !(await acl.allowed([
                "admin",
                "ordem_servicos",
                "index",
              ])),
            },
          ],
        },
        {
          title: "Análises",
          icon: "fa fa-fw fa-user-secret",
          badge: badgeAnalises,
          child: [
            {
              href: "/app/analises/minhas-analises",
              title: "Minhas análises",
              icon: "fa fa-fw fa-user",
              badge: badgeAnalises,
              disabled: !(await acl.allowed([
                "admin",
                "ordem_servicos",
                "analise",
                "minhas_analises",
                "index",
              ])),
            },
            {
              href: "/app/analises/analises",
              title: "Todas as análises",
              icon: "fa fa-fw fa-list",
              disabled: !(await acl.allowed([
                "admin",
                "ordem_servicos",
                "analise",
                "index",
              ])),
            },
          ],
        },
        {
          title: "Doc",
          icon: "fa fa-fw fa-exclamation-triangle",
          child: [
            {
              href: "/app/fiscalizacao/docs",
              title: "Documentos",
              icon: "fa fa-fw fa-exclamation-triangle",
              disabled: !(await acl.allowed([
                "admin",
                "fiscalizacao",
                "docs",
                "index",
              ])),
            },
            {
              href: "/app/fiscalizacao/doc-implantacoes",
              title: "Implantar",
              icon: "fa fa-fw fa-money fa-sm",
              disabled: !(await acl.allowed([
                "admin",
                "fiscalizacao",
                "doc_implantacoes",
                "index",
              ])),
            },
            {
              href: "/app/fiscalizacao/doc-implantados",
              title: "Implantados",
              icon: "fa fa-fw fa-usd fa-sm",
              disabled: !(await acl.allowed([
                "admin",
                "fiscalizacao",
                "doc_implantados",
                "index",
              ])),
            },
            {
              href: "/app/fiscalizacao/doc-comentarios",
              title: "Comentários",
              icon: "fa fa-fw fa-comments fa-sm",
              disabled: !(await acl.allowed([
                "admin",
                "fiscalizacao",
                "doc_comentarios",
                "index",
              ])),
            },
            {
              href: "/app/fiscalizacao/doc-publicacoes",
              title: "Publicações",
              icon: "fa fa-fw fa-file-text fa-sm",
              disabled: !(await acl.allowed([
                "admin",
                "fiscalizacao",
                "doc_publicacoes",
                "index",
              ])),
            },
            {
              href: "/app/fiscalizacao/doc-detalhados",
              title: "Detalhados",
              icon: "fa fa-fw fa-book fa-sm",
              disabled: !(await acl.allowed([
                "admin",
                "fiscalizacao",
                "doc_detalhados",
                "index",
              ])),
            },
          ],
        },
        {
          title: "Consultas",
          icon: "fa fa-fw fa-search",
          child: [
            {
              href: "/app/osm/consultas/cadastros",
              icon: "fa fa-fw fa-file-text",
              title: "Cadastros",
              disabled: !(await acl.allowed(["admin", "cadastros", "index"])),
            },
            {
              href: "/app/osm/consultas/cadastros/alvaras-vencer",
              icon: "fa fa-fw fa-file-text",
              title: "Alvarás à Vencer",
              disabled: !(await acl.allowed([
                "admin",
                "cadastros",
                "alvaras_vencer",
                "index",
              ])),
            },
            {
              title: "Documentos",
              icon: "fa fa-fw fa-exclamation-triangle",
              child: [
                {
                  href: "/app/osm/consultas/docs",
                  title: "Geral (todos departamentos)",
                  disabled: !(await acl.allowed([
                    "admin",
                    "consulta",
                    "docs",
                    "index",
                  ])),
                },
                {
                  href: "/app/osm/consultas/docs/por-irregularidade",
                  title: "Por Irregularidade",
                  disabled: !(await acl.allowed([
                    "admin",
                    "consulta",
                    "docs",
                    "por_irregularidade",
                    "index",
                  ])),
                },
              ],
            },
            {
              href: "/app/osm/consultas/pagamentos",
              icon: "fa fa-fw fa-money",
              title: "Pagamentos",
              disabled: !(await acl.allowed(["admin", "pagamentos", "index"])),
            },
            {
              href: "/app/osm/consultas/usuarios-geos",
              icon: "fa fa-fw fa-map-marker",
              title: "Fiscais no mapa",
              disabled: !(await acl.allowed(["admin", "usuarios_geos"])),
            },
          ],
        },
        {
          title: "Produtividade",
          icon: "fa fa-fw fa-line-chart",
          href: "/app/produtividade/geral",
          disabled: !(await acl.allowed([
            "admin",
            "produtividade",
            "geral",
            "index",
          ])),
        },
        {
          title: "",
          header: true,
        },
        {
          title: "Indicadores",
          icon: "fa fa-fw fa-tachometer",
          child: [
            {
              href: "/app/indicadores/analises",
              icon: "fa fa-fw fa-user-secret",
              title: "Análises",
            },
            {
              href: "/app/indicadores/osm",
              icon: "fa fa-fw fa-check-square-o",
              title: "OS-m",
            },
            {
              href: "/app/indicadores/docs",
              icon: "fa fa-fw fa-file-text",
              title: "Documentos",
            },
            {
              href: "/app/indicadores/produtividade",
              icon: "fa fa-fw fa-line-chart",
              title: "Produtividade",
            },
          ],
        },
        {
          title: "",
          header: true,
        },
        {
          title: "Configurações",
          icon: "fa fa-fw fa-cogs",
          child: [
            {
              href: "/app/sistema/doc-modelos",
              icon: "fa fa-fw fa-file-text",
              title: "Modelos de Documento",
              disabled: !(await acl.allowed([
                "admin",
                "sistema",
                "doc_modelos",
                "index",
              ])),
            },
            {
              title: "Usuários",
              icon: "fa fa-fw fa-users",
              child: [
                {
                  href: "/app/sistema/usuarios",
                  title: "Listar usuários",
                  disabled: !(await acl.allowed([
                    "admin",
                    "sistema",
                    "usuarios",
                    "index",
                  ])),
                },
                {
                  href: "/app/sistema/ausentes",
                  title: "Ausentes",
                  disabled: !(await acl.allowed([
                    "admin",
                    "sistema",
                    "ausentes",
                    "index",
                  ])),
                },
                {
                  href: "/app/sistema/usuario-grupos",
                  title: "Grupos de usuários",
                  disabled: !(await acl.allowed([
                    "admin",
                    "usuario_grupos",
                    "index",
                  ])),
                },
                {
                  href: "/app/sistema/perfis",
                  title: "Perfis",
                  disabled: !(await acl.allowed([
                    "admin",
                    "sistema",
                    "perfis",
                    "index",
                  ])),
                },
              ],
            },
            {
              title: "OS-m",
              icon: "fa fa-fw fa-check-square-o",
              child: [
                {
                  href: "/app/parametros/servicos/assuntos",
                  title: "Assuntos",
                  disabled: !(await acl.allowed([
                    "admin",
                    "assuntos",
                    "index",
                  ])),
                },
                {
                  href: "/app/parametros/servicos/formularios",
                  title: "Formulários",
                  disabled: !(await acl.allowed([
                    "admin",
                    "formularios",
                    "index",
                  ])),
                },
              ],
            },
            {
              href: "/app/sistema/produtividade-params",
              icon: "fa fa-fw fa-line-chart",
              title: "Parâm. de Produtividade",
              disabled: !(await acl.allowed([
                "admin",
                "sistema",
                "produtividade_params",
                "show",
              ])),
            },
            {
              href: "/app/cadastro-restritos",
              icon: "fa fa-fw fa-lock",
              title: "Cadastros restritos",
              disabled: !(await acl.allowed([
                "admin",
                "cadastro_protegido",
                "index",
              ])),
            },
            {
              href: "/app/sistema/legislacoes",
              icon: "fa fa-fw fa-balance-scale",
              title: "Legislações",
              disabled: !(await acl.allowed([
                "admin",
                "sistema",
                "legislacoes",
                "index",
              ])),
            },
            {
              href: "/app/sistema/job-outputs",
              icon: "fa fa-fw fa-tasks",
              title: "Logs de integração",
              disabled: !(await acl.allowed([
                "admin",
                "sistema",
                "job_outputs",
                "index",
              ])),
            },
          ],
        },
        {
          title: "",
          header: true,
        },
        {
          title: "Mensagens",
          icon: "fa fa-fw fa-envelope-o",
          href: "/app/mensagens",
          badge: badgeMensagens,
        },
        {
          title: "",
          header: true,
        },
        {
          href: "/app/manuais",
          title: "Manuais",
          icon: "fa fa-fw fa-book",
        },
        {
          href: "/app/sobre",
          title: "Sobre",
          icon: "fa fa-fw fa-info-circle",
        },
      ]
    },
  },
}
</script>

<style lang="stylus">
@import '../../styles/_variables.styl';

.app-menu {
  display: flex;
  height: 100%;

  .v-sidebar-menu {
    width: 250px;
    flex: 1;
    user-select: none;
    position: inherit;
    background-color: bg-color;
    z-index: 99;

    &.vsm_expanded .vsm--item_open .vsm--link {
      background-color: bg-color-light;
    }

    &.vsm_collapsed .vsm--item_open .vsm--link {
      background-color: bg-color;
      color: primary-color;
    }

    &.vsm_collapsed .vsm--item {
      background-color: bg-color-dark;

      .vsm--title {
        color: gray;
      }

      .vsm--link:hover {
        background-color: bg-color-dark !important;
      }
    }

    .vsm--list {
      .vsm--item .vsm--link {
        color: gray;
        cursor: pointer;

        &:focus {
          outline: none;
          color: primary-color;
        }

        &:hover {
          background-color: bg-color-light;
          cursor: pointer;
          color: primary-color;

          &.router-link-active {
            background-color: bg-color-light;
            color: primary-color;
          }
        }

        &.router-link-active {
          color: primary-color;
          background-color: bg-color-light;
        }

        .vsm--icon {
          background-color: transparent;
          color: gray;
        }
      }

      .vsm--header {
        background-color: bg-color-dark;
        padding: 0 10px;
        min-height: 1px;
        opacity: 0.7;
      }
    }

    .vsm--toggle-btn {
      position: inherit;
      background-color: bg-color-light;
      outline: none;
      color: primary-color;

      &::after {
        content: '\f07e';
        font-family: FontAwesome;
      }
    }

    .vsm--arrow::after {
      content: '\f105';
      font-family: FontAwesome;
    }

    .router-link-active {
      background-color: bg-color-dark;
    }

    .vsm--dropdown > .vsm--list {
      background: padding-right;
    }

    &.vsm--default {
      background: bg-color;

      .vsm--item.first-item.open-item > .vsm--link {
        background: bg-color-light;
      }
    }

    .vsm--dropdown > .vsm--list {
      background: bg-color;

      .vsm--item > .vsm--link {
        font-size: 0.7rem;
        padding-left: 30px !important;
      }
    }

    .vsm--item.first-item.active-item > .vsm--link, .vsm--item.first-item.parent-active-item > .vsm--link {
      box-shadow: inset 4px 0 0 0 bg-color-light;
    }

    .vsm--mobile-bg {
      background: bg-color-light;
    }

    .vsm--dropdown > .vsm--list {
      padding: 0;
    }
  }

  .vsm--collapsed {
    .vsm--dropdown > .vsm--list {
      .vsm--item > .vsm--link {
        padding-left: 10px !important;
      }
    }
  }
}
</style>
